import {AxiosResponse} from "axios";
import {BaseQueryOptions, BaseUseQueryResult, useBaseQuery} from "@bounce/shared/requests";
import {axiosReachInstance} from "../../ReachApiManager";
import {TRIGGER_ACCOUNT_PAYLOAD_QUERY_KEY} from "../queryKeys";
import {TriggerAccountPayload, TriggerInteractionType} from "./types";

type Variables = {interactionType: TriggerInteractionType; accountId: number};

const getTriggerAccountPayload = async (variables: Variables): Promise<TriggerAccountPayload> => {
  const response = await axiosReachInstance.get<TriggerAccountPayload, AxiosResponse<TriggerAccountPayload>>(
    `/triggers/account-payload/${variables.interactionType}`,
    {params: {account_id: variables.accountId}}
  );
  return response.data;
};

export const useGetTriggerAccountPayload = (
  variables: Variables,
  options?: BaseQueryOptions<TriggerAccountPayload, Variables>
): BaseUseQueryResult<TriggerAccountPayload> =>
  useBaseQuery<TriggerAccountPayload, Variables>(
    [TRIGGER_ACCOUNT_PAYLOAD_QUERY_KEY, variables.interactionType, variables.accountId],
    getTriggerAccountPayload,
    variables,
    options
  );
